<template>
  <div id="assignCoupon" class="assign-coupon">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toCouponList">优惠劵/</span>发放优惠券
      </template>
      <template v-slot:content>
        <ul class="base-info" ref="baseInfo">
          <li class="item">优惠券名称：{{ coupon.name }}</li>
          <li class="item">面值：{{ coupon.faceValue }}元</li>
          <li class="item">使用条件：满{{ coupon.baseMoney }}元可以使用</li>
          <li class="item" v-if="coupon.timeType === timeTypes.rangeTime">
            有效时间：{{ coupon.beginTime }} 至 {{ coupon.endTime }}
          </li>
          <li class="item" v-else>
            有效时间：领取后{{ coupon.effectiveTime }}内有效
          </li>
        </ul>
        <div class="desc">选择客户</div>
        <div class="select-customer-container">
          <div class="top">
            <span class="mini-title"
              >已选客户 {{ selectedCustomerList.length }}</span
            >
            <span class="add-customer-btn" @click="toSelectCustomer"
              >+选择客户</span
            >
          </div>
          <div class="batch-distribution">
            <i class="el-icon-warning"></i>
            <div class="batch-distribution-nums">
              <span>已选择</span>
              <span class="select-nums">{{ selectBatchModifyCustomerList.length }}</span>
              <span>项</span>
            </div>
            <div class="batch-modify" @click="batchModify">批量修改</div>
          </div>
          <div class="table">
            <el-table
              class="selected-customer-list"
              :data="selectedCustomerList"
              @selection-change="handleBatchSelectionChange"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="序号" prop="xbId"></el-table-column>
              <el-table-column label="客户名称" prop="name"></el-table-column>
              <el-table-column label="用户名" prop="userName"></el-table-column>
              <el-table-column label="数量">
                <template slot-scope="props">
                  <el-input
                    v-model="props.row.nums"
                    class="gray nums"
                    placeholder="请输入数量"
                    @input="inputUnitPrice(props.row, props.row.nums)"
                  >
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="props">
                  <span class="delete-btn" @click="deleteCustomer(props.row)"
                    >删除</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="bottom">
            <span class="tip">提示：优惠券发放后，不可撤回或者删除</span>
          </div>
        </div>
        <div class="operations" ref="operations">
          <el-button class="btn-white" @click="toCouponList">取消</el-button>
          <el-button class="btn-blue" @click="toAssignCoupon">发放</el-button>
        </div>
        <!-- 选择客户--弹框 -->
        <el-dialog
          class="add-customer-container"
          :visible.sync="isShowCustomerDialog"
        >
          <span slot="title">选择客户</span>
          <div class="content">
            <div class="search-key-tag">
              <div class="search-key">
                <el-input
                  v-model="filterCustomer.key"
                  class="gray"
                  placeholder="请输入客户名称或手机号"
                  clearable
                ></el-input>
              </div>
              <div class="search-tag">
                <el-select
                  class="gray"
                  v-model="filterCustomer.tagId"
                  placeholder="请选择客户标签"
                  clearable
                >
                  <el-option
                    v-for="item in customerTagList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <el-button class="btn-blue" @click="searchCustomer"
                >搜索</el-button
              >
            </div>
            <!-- 客户列表 -->
            <div class="customer-list table">
              <el-table
                ref="multipleTable"
                class="table-container"
                :data="customerList"
                height="250"
                :row-key="getRowKeys"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
                <!-- <el-table-column label="是否选择" align="center">
                  <template slot-scope="props">
                    <el-checkbox v-model="props.row.isSelected"></el-checkbox>
                  </template>
                </el-table-column> -->
                <el-table-column
                  label="客户名称"
                  prop="name"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="登陆账号"
                  prop="userName"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="手机号"
                  prop="telephone"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="账号状态"
                  prop="statusDesc"
                  align="center"
                >
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-container">
              <pagination-tpl
                :total="customerTotalNum"
                :currentPage="customerPage"
                @queryChange="onQueryChnage"
              ></pagination-tpl>
            </div>
            <div class="operation">
              <el-button class="btn-white" @click="cancelCustomer"
                >取消</el-button
              >
              <el-button class="btn-blue" @click="saveCustomer">保存</el-button>
            </div>
          </div>
        </el-dialog>
        <!-- 批量修改 -->
        <el-dialog class="dialogBatchModify" title="批量修改" :visible.sync="dialogBatchModifyVisible" width="420px" top="20vh">
          <p class="dialogBatchModify-title">请确认需修改客户优惠券的数量</p>
          <div class="dialogBatchModify-nums">
            <div class="dialogBatchModify-label">数量：</div>
            <el-input
              class="white"
              v-model="batchNums"
              placeholder="请输入数量"
            ></el-input>
          </div>
          <div slot="footer" class="dialogBatchModify-footer">
            <el-button class="btn-white" type="primary" @click="dialogBatchModifyVisible = false">取消</el-button>
            <el-button class="btn-blue" type="primary" @click="confirm">确认</el-button>
          </div>
        </el-dialog>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import { formatTimeToDate } from "common/js/util";
import DBClient from "models/db/client.js";
import DBCoupon from "models/db/coupon";
const dbClient = new DBClient();
const dbCoupon = new DBCoupon();
const timeTypes = {
  rangeTime: 1,
  effectiveTime: 2,
};
const customerStatusToDesc = {
  0: "未审核",
  1: "已启用",
  2: "已禁用",
};
export default {
  data() {
    return {
      timeTypes,
      coupon: {
        name: "测试优惠券",
        faceValue: 20,
        baseMoney: 100,
        timeType: timeTypes.rangeTime,
        beginTime: "2019-08-20",
        endTime: "2019-08-22",
        effectiveTime: 3,
      },
      // 临时编辑被选择的客户列表
      tmpSelectedCustomerList: [],
      // 已选择的客户列表
      selectedCustomerList: [],
      // 选择客户弹框相关
      isShowCustomerDialog: false,
      filterCustomer: {
        tagId: "",
        key: "",
      },
      customerTagList: [],
      // 客户总条数
      customerTotalNum: 0,
      customerPage: 1,
      // 所有的客户列表
      customerList: [
        {
          isSelected: true,
          name: "客户名称",
          userName: "登陆账号",
          telephone: "13574963581",
          statusDesc: "已启用",
        },
      ],
      /* -------------------------------- 以下是批量修改字段 ---------------------------- */
      dialogBatchModifyVisible: false,
      batchNums: null,                          // 批量修改数量
      selectBatchModifyCustomerList: [],        // 选择批量修改的客户
    };
  },
  watch: {
    isShowCustomerDialog(newVal) {
      if (!newVal) {
        this._resetCustomerToUnselect();
      }
    },
    // customerList: {
    //   deep: true,
    //   handler(newVal) {
    //     newVal.map((customer) => {
    //       // 先判断 customer 在不在 this.tmpSelectedCommodityList列表
    //       let isHave = this.tmpSelectedCustomerList.find(
    //         (selectedCustomer) => selectedCustomer.xbId === customer.xbId
    //       );
    //       if (customer.isSelected) {
    //         if (!isHave) {
    //           // 新选中客户
    //           this.tmpSelectedCustomerList.push(customer);
    //         }
    //       } else {
    //         if (isHave) {
    //           // 剔除
    //           let index = this.tmpSelectedCustomerList.findIndex(
    //             (selectedCustomer) => selectedCustomer.xbId === customer.xbId
    //           );
    //           this.tmpSelectedCustomerList.splice(index, 1);
    //         }
    //       }
    //     });
    //     console.log("被选中的客户", this.tmpSelectedCustomerList);
    //   },
    // },
  },
  methods: {
    /* 限制数量为整数 */
    inputUnitPrice(row, val) {
      let price = val.toString().match(/^(\+)?\d*/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^(\+)?\d*/g)[0]
        : "";
      this.$set(row, "nums", price);
    },
    toCouponList() {
      this.$router.push({
        path: "/admin/marketing/coupon/coupon-list",
      });
      // window.location.reload()
    },
    toAssignCoupon() {
      let couponCountList = [];
      if (this.selectedCustomerList.length) {
        this.selectedCustomerList.map((customer) => {
          let obj = {};
          obj.cusId = customer.userId;
          obj.count = Number(customer.nums);
          couponCountList.push(obj);
        });
      }
      let data = {
        id: this.$route.query.couponId,
        couponCountList,
      };
      this._assignCoupon(data);
    },
    toSelectCustomer() {
      this._showCustomerDialog();
    },
    searchCustomer() {
      this.customerPage = 1
      this._getClientList();
    },
    onQueryChnage(query) {
      this.customerPage = query.currentPage
      this._getClientList();
    },
    cancelCustomer() {
      this._resetCustomerToUnselect();
      this._hideCustomerDialog();
    },
    getRowKeys(row) {
      return row.xbId
    },
    handleSelectionChange(val) {
      this.tmpSelectedCustomerList = val
    },
    saveCustomer() {
      // this.tmpSelectedCustomerList.map((customer) => {
      //   let isHave = this.selectedCustomerList.find(
      //     (selectedCustomer) => selectedCustomer.xbId === customer.xbId
      //   );
      //   // 不重复才添加
      //   if (!isHave) {
      //     this.selectedCustomerList.push(customer);
      //   }
      // });
      this.selectedCustomerList = this.tmpSelectedCustomerList
      // console.log("已选择的客户列表", this.selectedCustomerList);
      // this.$refs.multipleTable.clearSelection()
      this._hideCustomerDialog();
    },
    deleteCustomer(customer) {
      let targetIndex = this.selectedCustomerList.findIndex(
        (selectedCustomer) => selectedCustomer.xbId === customer.xbId
      );
      this.selectedCustomerList.splice(targetIndex, 1);
    },
    _showCustomerDialog() {
      this.isShowCustomerDialog = true;
    },
    _hideCustomerDialog() {
      this.isShowCustomerDialog = false;
    },
    _resetCustomerToUnselect() {
      this.customerList.map((customer) => {
        customer.isSelected = false;
      });
    },
    // 发放优惠券
    _assignCoupon(data) {
      dbCoupon.assignCoupon(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "发放成功",
            center: true,
            type: "success",
            duration: 1000,
          });
          this.toCouponList();
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    // 获取客户标签
    _getClientTagList() {
      dbClient.getClientTagList().then((res) => {
        if (res.success) {
          console.log("客户标签列表--", res.result);
          // 先置空
          this.customerTagList = [];
          res.result.map((item) => {
            this.customerTagList.push({
              value: item.id,
              label: item.value,
            });
          });
        } else {
          console.log("客户标签列表失败", res.message);
        }
      });
    },
    // 获取所有客户
    _getClientList() {
      const telephoneReg = /^1[0-9]{10}$/;
      let isTelephone = telephoneReg.test(Number(this.filterCustomer.key));
      let options = {
        name: isTelephone ? "" : this.filterCustomer.key,
        telephone: isTelephone ? this.filterCustomer.key : "",
        label: this.filterCustomer.tagId,
        currentPage: this.customerPage,
      };
      dbClient.getClientList(options).then((res) => {
        if (res.success) {
          let { totalNum, items } = res.result;
          this.customerTotalNum = totalNum;
          // 先置空
          this.customerList = [];
          items.map((item) => {
            let tagList = item.cusLabelValue ? item.cusLabelValue : [];
            let tags = [];
            tagList.map((item) => {
              tags.push({
                id: item.customerLabelId,
                name: item.name,
              });
            });
            this.customerList.push({
              isSelected: false,
              userId: item.userId,
              xbId: item.id,
              name: item.name,
              // 登陆账号
              userName: item.userName,
              telephone: item.telephone,
              nums: 1,
              status: item.status,
              statusDesc: customerStatusToDesc[item.status],
            });
          });
        } else {
          // 请求客户列表失败
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    // 获取优惠券相关信息
    _getCouponDetail(couponId) {
      dbCoupon.getCouponDetail(couponId).then((res) => {
        if (res.success) {
          console.log("优惠券相关信息", res.result);
          let { coupon } = res.result;
          console.log("优惠券详情", coupon);
          let {
            title,
            faceValue,
            baseMoney,
            timeType,
            beginTime,
            endTime,
            effectiveTime,
          } = coupon;
          this.coupon.name = title;
          this.coupon.faceValue = faceValue;
          this.coupon.baseMoney = baseMoney;
          this.coupon.timeType = timeType;
          this.coupon.beginTime = formatTimeToDate(beginTime);
          this.coupon.endTime = formatTimeToDate(endTime);
          this.coupon.effectiveTime = effectiveTime;
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },

    /* ------------------------------------ 以下是批量发放的方法 ------------------------------------- */
    /* 选择批量修改客户 */
    handleBatchSelectionChange(val) {
      this.selectBatchModifyCustomerList = val
    },
    confirm() {
      this.selectBatchModifyCustomerList.map(v => {
        this.selectedCustomerList.map(i => {
          if (v.userId === i.userId) {
            i.nums = this.batchNums
          }
        })
      })
      this.dialogBatchModifyVisible = false
    },
    /* 打开批量修改 */
    batchModify() {
      if (this.selectBatchModifyCustomerList.length === 0) {
        this.$message.error('请先选择批量修改的客户')
        return
      }
      this.dialogBatchModifyVisible = true
    }
  },
  created() {
    // 获取优惠券详情
    this._getCouponDetail(this.$route.query.couponId);
    // 获取所有客户标签
    this._getClientTagList();
    // 获取所有客户列表
    this._getClientList();
  },
  mounted() {
    const paddingWidth = 52;
    this.$refs.operations.style.width =
      this.$refs.baseInfo.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.baseInfo.clientWidth + paddingWidth + "px";
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
  },
};
</script>

<style lang="scss" scoped>
.assign-coupon {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .base-info {
    font-size: 14px;
    color: #666666;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 4px;
    padding: 20px 0 20px 30px;
    .item {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
  .desc {
    margin-top: 20px;
    margin-bottom: 16px;
    height: 32px;
    background: rgba(245, 247, 250, 1);
    border-radius: 8px 8px 0px 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 6px;
    font-size: 16px;
    color: #333333;
    font-weight: 400;
  }
  .select-customer-container {
    width: 1000px;
    background: rgba(251, 251, 251, 1);
    border-radius: 4px;
    font-size: 14px;
    padding-left: 20px;
    padding-right: 24px;
    .top {
      box-sizing: border-box;
      width: 100%;
      height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .mini-title {
        color: #666666;
      }
      .add-customer-btn {
        color: #3d74f2;
        cursor: pointer;
      }
    }
    .batch-distribution {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      height: 32px;
      background: #E6F7FF;
      border: 1px solid #BAE7FF;
      border-radius: 4px;
      margin-bottom: 16px;
      padding: 0px 16px;
      .el-icon-warning {
        width: 14px;
        height: 14px;
        color: #409EFF;
        margin-right: 14px;
      }
      .batch-distribution-nums {
        margin-right: 31px;
        .select-nums {
          padding: 0px 6px;
          color: #409EFF;
        }
      }
      .batch-modify {
        color: #409EFF;
        cursor: pointer;
      }
    }
    .delete-btn {
      color: #3d74f2;
      cursor: pointer;
    }
    .bottom {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tip {
        height: 52px;
        line-height: 52px;
        font-size: 12px;
        color: #df3445;
        margin-bottom: 30px;
      }
    }
  }
  .operations {
    height: 60px;
    position: fixed;
    left: 256px;
    bottom: 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    .btn-white {
      margin-right: 20px;
    }
  }
  .add-customer-container {
    .content {
      padding-top: 16px;
      border-top: 1px solid #e3e3e3;
      .search-key-tag {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;
        .search-tag {
          margin: 0 12px;
        }
      }
      .customer-list {
        max-height: 400px;
        overflow: auto;
        .tags {
          box-sizing: border-box;
          border: 1px solid red;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          .tag {
            box-sizing: border-box;
            margin-right: 10px;
            width: 80px;
            height: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 2px 4px;
            font-size: 12px;
            color: rgba(96, 98, 102, 1);
            border-radius: 6px;
            background: skyblue;
            cursor: pointer;
            &:last-child {
              margin-right: 0px;
            }
          }
        }
        .tip {
          width: 100%;
        }
      }
      .pagination-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
      .operation {
        display: flex;
        justify-content: center;
        align-items: center;
        .btn-white {
          margin-right: 24px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.assign-coupon {
  .el-input.nums .el-input__inner {
    height: 22px;
  }
  .dialogBatchModify {
    .el-dialog__header {
      color: #666666;
      font-size: 16px;
      padding: 0;
      padding-left: 20px;
      border-bottom: 1px solid #eee;
    }
    .el-dialog__body {
      padding: 20px 45px 20px 32px;
    }
    .dialogBatchModify-title {
      color: #999999;
      font-size: 14px;
    }
    .dialogBatchModify-nums {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-top: 20px;
      .dialogBatchModify-label {
        width: 60px;
      }
    }
    .el-dialog__footer {
      padding: 20px 0px;
      border-top: 1px solid #eee;
      .dialogBatchModify-footer {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
